import { Form, Icon, Input, Button, Checkbox, Spin } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import React from 'react';
import { Redirect, RouteProps, NavLink } from 'react-router-dom';
import AuthContext from '../../../Context/AuthContext';
import FormControl from '../../Forms/FormControl';
import { StyleConfirmJointHolderForm } from './ConfirmJointHolderForm.Style';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import { ConfirmJointHolderFormHandler } from './ConfirmJointHolderFormHandler';
import ValidationUtility from 'Core/ValidationUtility';
import queryString from 'query-string';

export interface Props extends FormComponentProps, RouteProps {
    children?: React.ReactNode;
}

export interface State {
    isConfirmed: boolean;
}

class BaseConfirmJointHolderForm extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    confirmJointHolderFormHandler: ConfirmJointHolderFormHandler;

    constructor(props: Props) {
        super(props);
        this.confirmJointHolderFormHandler = new ConfirmJointHolderFormHandler(props);
        this.state = { isConfirmed: false };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        // if (this.context.data) {
        //   this.setState({ isConfirmed: true });
        // }
    }

    handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        const query = queryString.parse(this.props?.location?.search);
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.confirmJointHolderFormHandler.ConfirmJointHolder(query.email, query.token, values.trn, values.firstName, values.lastName).then(user => {
                    this.setState({ isConfirmed: true });
                });
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        let state: { from?: any; noPermission?: boolean } = {};

        if (this.props.location) {
            state = this.props.location.state || {};
        }


        return (
            <StyleConfirmJointHolderForm onSubmit={this.handleSubmit}>



                <FormControl
                    getFieldDecorator={getFieldDecorator}
                    rules={[...ValidationUtility.required('TRN is required')]}
                    name="trn" //getFieldDecorator(name: { hidden: true })
                    label="TRN">
                    <Input />
                </FormControl>
                <FormControl
                    getFieldDecorator={getFieldDecorator}
                    rules={[...ValidationUtility.required('first name is required')]}
                    name="firstName" //getFieldDecorator(name: { hidden: true })
                    label="First Name">
                    <Input />
                </FormControl>
                <FormControl
                    getFieldDecorator={getFieldDecorator}
                    rules={[...ValidationUtility.required('last name is required')]}
                    name="lastName" //getFieldDecorator(name: { hidden: true })
                    label="Last Name">
                    <Input />
                </FormControl>

                <Button className="" type="primary" htmlType="submit">
                    Submit
            </Button>

            </StyleConfirmJointHolderForm>
        );
    }

    private ShouldRedirectTo(state: { from?: any; noPermission?: boolean | undefined }): boolean {
        return !!state.from && state.from.pathname !== '/logout';
    }
}

const ConfirmJointHolderForm = Form.create<Props>({
    name: 'Confirm',
})(BaseConfirmJointHolderForm);

export default ConfirmJointHolderForm;



